<script setup lang="ts">
import { shallowRef, watchEffect } from 'vue'
import type { EDividerElements, IDividerProps } from './types'
import { isDark } from '@/lib/utils'
import useDividerConfig from '@/ui/plushComponents/VDivider/composables/useDividerConfig'

const props = withDefaults(defineProps<IDividerProps>(), {
    variant: 'subtlest',
    orientation: 'horizontal',
})

const dividerConfig = shallowRef<Record<EDividerElements, string>>({} as Record<EDividerElements, string>)

watchEffect(() => {
    dividerConfig.value = useDividerConfig(props)
})
</script>

<template>
    <div
        :class="[isDark(props.dark), dividerConfig.root]"
        data-gpp-tools-ui
    />
</template>
